
import { supabase } from "@/integrations/supabase/client";
import { User, Session } from "@supabase/supabase-js";

export const useAuthListeners = (
  setUser: (user: User | null) => void,
  setSession: (session: Session | null) => void,
  setIsLoading: (isLoading: boolean) => void,
  setAuthEvent: (event: string | null) => void
) => {
  const initializeAuth = async () => {
    try {
      console.log("Initializing auth state...");
      const { data: { session: existingSession } } = await supabase.auth.getSession();
      console.log("Existing session check:", existingSession?.user?.id || "No session found");
      
      if (existingSession) {
        setSession(existingSession);
        setUser(existingSession.user);
      }
      
      setIsLoading(false);
    } catch (err) {
      console.error("Error checking session:", err);
      setIsLoading(false);
    }
  };

  const setupAuthListener = () => {
    console.log("Setting up auth state listener...");
    const { data: { subscription } } = supabase.auth.onAuthStateChange(
      (event, newSession) => {
        console.log("Auth state changed:", event, newSession?.user?.id || "No user");
        setSession(newSession);
        setUser(newSession?.user ?? null);
        setAuthEvent(event);
        setIsLoading(false);
      }
    );
    
    return subscription;
  };

  return {
    initializeAuth,
    setupAuthListener
  };
};
